// extracted by mini-css-extract-plugin
module.exports = {"imgWarp":"Title_imgWarp__2k7rI","word":"Title_word__3tWVV","title":"Title_title__1Xzi2"};